<template>
  <div class="dashboard-revenue-split">
    <div class="rev-header">
      <div>
        <h3 class="rev-title">{{ $t('org-dashboard.revenue-split') }}</h3>
        <p class="rev-subtitle">{{ $t('org-dashboard.revenue-subtitle') }}</p>
      </div>
      <v-btn x-small outlined @click="$emit('view-report')">{{ $t('org-dashboard.view-report') }}</v-btn>
    </div>
    <template v-if="total === 0">
      <div class="rev-empty">
        <v-icon color="grey lighten-1" size="32">mdi-cash-off</v-icon>
        <p class="rev-empty-text">{{ $t('org-dashboard.no-billing') }}</p>
      </div>
    </template>
    <template v-else>
      <div class="rev-total-row">
        <span class="rev-total">{{ formattedTotal }}</span>
        <span v-if="change !== null && change !== undefined" class="rev-change" :class="change >= 0 ? 'rev-change--up' : 'rev-change--down'">
          <v-icon x-small>{{ change >= 0 ? 'mdi-trending-up' : 'mdi-trending-down' }}</v-icon>
          {{ change >= 0 ? '+' : '' }}{{ change }}%
        </span>
      </div>
      <div class="rev-bar-wrap" v-if="segments && segments.length">
        <div class="rev-bar-labels">
          <span v-for="(seg, i) in segments" :key="'l' + i" class="rev-bar-label">{{ seg.label }} ({{ seg.percent }}%)</span>
        </div>
        <div class="rev-bar">
          <div
            v-for="(seg, i) in segments"
            :key="i"
            class="rev-bar-segment"
            :style="{width: seg.percent + '%', backgroundColor: seg.color}"
          >
            <span class="rev-bar-segment-text" v-if="seg.percent >= 15">{{ seg.label }}</span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'DashboardRevenueSplit',
  props: {
    total: { type: Number, default: 0 },
    currency: { type: String, default: 'EUR' },
    change: { type: Number, default: null },
    segments: { type: Array, default: () => [] },
  },

  computed: {
    formattedTotal() {
      return new Intl.NumberFormat(this.$i18n.locale, {
        style: 'currency',
        currency: this.currency,
      }).format(this.total)
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-revenue-split {
  background: white;
  border-radius: 12px;
  padding: 20px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.rev-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.rev-title {
  font-size: 14px;
  font-weight: 700;
  color: #1f2937;
}

.rev-subtitle {
  font-size: 11px;
  color: #6b7280;
  margin-top: 2px;
}

.rev-total-row {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin: 16px 0;
}

.rev-total {
  font-size: 28px;
  font-weight: 700;
  color: #111827;
}

.rev-change {
  font-size: 11px;
  font-weight: 700;
  padding: 2px 6px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  gap: 2px;

  &--up {
    color: #059669;
    background: #ecfdf5;
  }
  &--down {
    color: #dc2626;
    background: #fef2f2;
  }
}

.rev-bar-wrap {
  margin-top: auto;
}

.rev-bar-labels {
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: #6b7280;
  font-weight: 500;
  margin-bottom: 6px;
}

.rev-bar {
  height: 24px;
  width: 100%;
  background: #f3f4f6;
  border-radius: 4px;
  display: flex;
  overflow: hidden;
}

.rev-bar-segment {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: width 0.5s ease;
}

.rev-bar-segment-text {
  font-size: 10px;
  font-weight: 500;
  color: white;
}

.rev-empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px 0;
}

.rev-empty-text {
  font-size: 13px;
  color: #9ca3af;
}
</style>
